import React from 'react';
import { Modal } from '@avangard/ui/core';

import type { ModalProps } from '@avangard/ui/core';

type LapFormModalProps = Omit<ModalProps, 'title' | 'children'> & {
    title: string;
    children: React.ReactNode;
};

const LapFormModal = (props: LapFormModalProps): React.ReactElement => {
    const { onClose, title, children, ...otherProps } = props;

    return (
        <Modal title={title} onClose={onClose} {...otherProps}>
            {children}
        </Modal>
    );
};

export { LapFormModal };
